import { Button, Radio, RadioGroup } from '@trackman/web-shared-components';
import { LeagueStrikeZoneEnum } from 'interfaces/session/IStrikeZoneDefinition';
import React from 'react';
import styled, { css } from 'styled-components';
import { brand, grey, modalGrey } from 'styles/Colors';

export const SelectStrikeZoneWrapper = styled.div`
  position: relative;
`;

export const StrikeZone = styled.div`
  margin-top: 20px;
`;

export const StyledRadioGroup = styled((props) => <RadioGroup {...props} />)`
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

export const Title = styled.div`
  font-family: Lato;
  font-size: 18px;
  font-weight: 700;
  line-height: 25.2px;
`;

export const Dimensions = styled.div`
  display: flex;
  gap: 10px;
`;

export const StrikeZoneValue = styled.span<{
  top?: number;
  left?: number;
  width?: number;
  height?: number;
  variant?: LeagueStrikeZoneEnum;
}>`
  color: white;
  font-size: 11px;
  font-weight: 700;
  line-height: 15.4px;
  position: absolute;
  top: ${(props) => props.top}px;
  left: ${(props) => props.left}px;
  width: ${(props) => props.width}px;
  height: ${(props) => props.height}px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(props) => (props.variant === LeagueStrikeZoneEnum.HeightBasedStrikeZone ? '#FE9800' : brand)};
  width: fit-content;
  border-radius: 2.55px;
  padding: 0 2px;
`;

export const StrikeZoneWrapper = styled.div<{ isPrivateGame: boolean; variant?: LeagueStrikeZoneEnum }>`
  position: relative;
  transform: ${(props) => (props.isPrivateGame ? 'translateX(-157px)' : 'translateX(-115px)')};
  margin-top: 22px;
  padding-bottom: 54px;
  margin-left: 24px;

  ${(props) =>
    props.variant === LeagueStrikeZoneEnum.HeightBasedStrikeZone &&
    css`
      svg {
        [id='top-bottom-arrow'],
        [id='top-arrow'],
        [id='bottom-arrow'] {
          fill: #fe9800;
        }
      }
    `}
`;

export const StyledRadio = styled((props) => <Radio {...props} />)`
  &&& {
    height: 20px;
  }

  .MuiTypography-root {
    padding: 0 8px 0 0;
  }

  div[class*='-icon-'],
  div[class*='-checkedIcon-'] {
    height: 16px;
    width: 16px;

    div {
      height: 10px;
      width: 10px;
    }
  }
`;

export const StrikeZoneExplanation = styled.div<{ isPrivateGame: boolean }>`
  position: absolute;
  top: 25px;
  left: ${(props) => (props.isPrivateGame ? '360px' : '370px')};
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  color: ${grey};
  height: 84px;
  width: 380px;
  display: flex;
  align-items: center;
`;

export const StrikeZoneSelect = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StrikeZoneValues = styled.div`
  display: flex;
  gap: 16px;
  margin-top: 25px;
`;

export const StyledButton = styled((props) => <Button {...props} />)`
  &&& {
    background-color: ${modalGrey};
    min-width: 32px;
    align-items: center;

    width: 32px;

    span {
      margin: 0;
    }
  }
`;

export const ResetWrapper = styled.div`
  display: flex;
  align-self: flex-end;
`;

export const Divider = styled.div`
  height: 16px;
  width: 1px;
  background-color: #414141;
`;
